// ─────────────────────────────────────────────────────────────────────────────
// ENVIRONMENT
// ─────────────────────────────────────────────────────────────────────────────

export const ENV = {
  API_BASE_URL:     process.env.NEXT_PUBLIC_API_BASE_URL    || 'http://localhost:8080',
  R2_PUBLIC_URL:    process.env.NEXT_PUBLIC_R2_PUBLIC_URL   || '',
  GOOGLE_CLIENT_ID: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || '',
  IS_PRODUCTION:    process.env.NODE_ENV === 'production',
} as const

/** Construct a user-uploaded image URL from an r2Key */
export function getUserImageUrl(r2Key: string): string {
  return `${ENV.R2_PUBLIC_URL}/${r2Key}`
}

// ─────────────────────────────────────────────────────────────────────────────
// API ENDPOINTS  (v2)
// ─────────────────────────────────────────────────────────────────────────────

const BASE = ENV.API_BASE_URL

export const API = {
  // ── Auth ──────────────────────────────────────────────────────────────────
  SIGNUP_REQUEST:          `${BASE}/api/users/signup/request`,
  SIGNUP_VERIFY:           `${BASE}/api/users/signup/verify`,
  LOGIN:                   `${BASE}/api/users/login`,
  GOOGLE_AUTH:             `${BASE}/api/users/auth/google`,
  REFRESH:                 `${BASE}/api/users/auth/refresh`,
  LOGOUT:                  `${BASE}/api/users/auth/logout`,
  LOGOUT_ALL:              `${BASE}/api/users/auth/logout-all`,
  PASSWORD_RESET_REQUEST:  `${BASE}/api/users/password-reset/request`,
  PASSWORD_RESET:          `${BASE}/api/users/password-reset/reset`,

  // ── Users ─────────────────────────────────────────────────────────────────
  ME:                      `${BASE}/api/users/me`,
  USER_PROFILE: (username: string) => `${BASE}/api/users/${username}`,

  // ── Items ─────────────────────────────────────────────────────────────────
  ITEMS:                   `${BASE}/api/items`,
  ITEMS_BULK:              `${BASE}/api/items/bulk`,
  ITEM:             (id: string) => `${BASE}/api/items/${id}`,
  ITEM_IMAGES:      (id: string) => `${BASE}/api/items/${id}/images`,
  ITEM_IMAGE:       (id: string, imageId: string) => `${BASE}/api/items/${id}/images/${imageId}`,
  ITEM_IMAGE_COVER: (id: string, imageId: string) => `${BASE}/api/items/${id}/images/${imageId}/cover`,
  ITEM_SYSTEM_NOTE: (id: string) => `${BASE}/api/items/${id}/system-note`,

  // ── Catalog ───────────────────────────────────────────────────────────────
  CATALOG_BRANDS:          `${BASE}/api/catalog/brands`,
  CATALOG_SEARCH:          `${BASE}/api/catalog/search`,
  CATALOG_PRODUCT:  (id: string) => `${BASE}/api/catalog/products/${id}`,
  CATALOG_DUPLICATES:      `${BASE}/api/catalog/duplicates`,
  CATALOG_SUBMISSIONS:     `${BASE}/api/catalog/submissions`,
  CATALOG_SUBMISSION: (id: string) => `${BASE}/api/catalog/submissions/${id}`,
  CATALOG_MOD_SUBMISSIONS: `${BASE}/api/catalog/moderation/submissions`,
  CATALOG_MOD_SUBMISSION: (id: string) => `${BASE}/api/catalog/moderation/submissions/${id}`,

  // ── Collections ───────────────────────────────────────────────────────────
  COLLECTIONS:             `${BASE}/api/collections`,
  COLLECTION:       (id: string) => `${BASE}/api/collections/${id}`,
  COLLECTION_MODELS: (id: string) => `${BASE}/api/collections/${id}/models`,
  COLLECTION_MODEL:  (id: string, modelId: string) => `${BASE}/api/collections/${id}/models/${modelId}`,

  // ── Uploads ───────────────────────────────────────────────────────────────
  UPLOAD_IMAGE:            `${BASE}/api/uploads/image`,
  DELETE_UPLOAD:    (key: string) => `${BASE}/api/uploads/${key}`,
} as const
